// extracted by mini-css-extract-plugin
export default {"single-column-flow-layout":"single-column-flow-layout-2747"};